import Card from "react-bootstrap/Card";
import "../style/card.css";
import svgTravel from "../assets/Travel.svg";
import svgExpenses from "../assets/Expenses.svg";
import svgFAQ from "../assets/FAQ.svg";
import svgMail from "../assets/Mail.svg";
import svgUser from "../assets/User.svg";
import svgRequests from "../assets/Requests.svg";
import svgCreditCard from "../assets/credit_card.svg";
import svgElectronicData from "../assets/electronic_data.svg";
import svgFinancialControlling from "../assets/financial_controlling.svg";
import svgAccountOwner from "../assets/account_owner.svg";
import svgHistory from "../assets/history.svg";
import svgPayment from "../assets/payment.svg";
import { faGlobe } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";

export default function CardTEA({
  link,
  title,
  ico,
  bigFont,
  height,
  width = "50%",
  padding,
  marginY = 3,
}) {
  const obSVGicons = {
    faPlane: svgTravel,
    faList: svgRequests,
    faEuroSign: svgExpenses,
    faUser: svgUser,
    faQuestion: svgFAQ,
    faEnvelope: svgMail,
    faGlobe: faGlobe,
    faCreditCard: svgCreditCard,
    faElectronicData: svgElectronicData,
    faFinancialControlling: svgFinancialControlling,
    faAccountOwner: svgAccountOwner,
    faHistory: svgHistory,
    svgPayment: svgPayment,
  };

  return (
    <Card
      as={Link}
      to={link}
      border="primary"
      className="px-0 overflow-hidden h-100 w-100 cardTEA"
      style={{ containerType: "inline-size" }}
    >
      <Card.Img
        src={obSVGicons[ico]}
        className={`my-${marginY} align-self-center`}
        style={{ aspectRatio: 1, width: width }}
      />
      <Card.Body
        className="bg-primary w-100 p-0 d-flex justify-content-center align-items-center"
        style={{
          height: "calc(14px + 12cqw)",
        }}
      >
        <Card.Title
          className="text-white m-0 text-center"
          style={{ fontSize: bigFont ? 28 : 16 }}
        >
          {title}
        </Card.Title>
      </Card.Body>
    </Card>
  );
}
